module.exports = __webpack_public_path__ + "static/media/burger-menu-icon.01384e36.svg";